import React from 'react';
import classnames from 'classnames';
import Util from "./Util.js";
import S from './MomentBackground.css';

/**
 * react class that renders header cells
 * @property {projection} projection the projection used to create the header
 * @property {string} unit the unit used to calculate the group. 'day', 'month', etc
 * @property {string} format if present, moment.format( format ) will be used to create the label
 * @property {function} dynamicClass if present, this function will be invoked with dynamicClass( moment, width, left, right ) and should return a className to add to the cell.
 * @property {string} className the className to apply to the background
 * @property {string} cellClassName the className to apply to each cell
 **/
import { jsx as _jsx } from "react/jsx-runtime";
class MomentBackground extends React.Component {
  render() {
    const {
      projection,
      unit,
      dynamicClass,
      className,
      cellClassName,
      reverse = false,
      timezone
    } = this.props;
    const {
      startValue: startTime,
      stopValue: stopTime
    } = projection;
    // const hWidth = projection.startToScreen( startTime ) - projection.startToScreen( stopTime )

    const lbl = [];
    let startDateTime = Util.parseDateTime(startTime, timezone).startOf(unit);
    const stopDateTime = Util.parseDateTime(stopTime, timezone);
    let t = startDateTime.valueOf();
    while (t < stopDateTime) {
      const left = projection.startToScreen(t);
      const curr = startDateTime;
      startDateTime = startDateTime.plus({
        [unit]: 1
      });
      t = startDateTime.valueOf();
      const right = projection.stopToScreen(t);
      const width = right - left;
      const dynName = dynamicClass && dynamicClass(curr, width, left, right);
      lbl.push(/*#__PURE__*/_jsx("div", {
        className: classnames(S.cell, cellClassName, dynName),
        style: {
          left: `${left}px`,
          width: `${width}px`
        }
      }, `{bg-${t}`));
    }
    return /*#__PURE__*/_jsx("div", {
      className: classnames(S.background, className),
      children: reverse ? lbl.reverse() : lbl
    });
  }
}
export default MomentBackground;